import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.daily.games,
    (task) => {
        return {
            task
        }
    }
)